import React from 'react';
import PropTypes from 'prop-types';

const Form = ({handleSubmit, children}) => {
  return (
    <form onSubmit={handleSubmit}>
      {children}
    </form>
  );
};

Form.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  children: PropTypes.array.isRequired
};

export default Form;



// WEBPACK FOOTER //
// ./containers/CheckoutPage/Form.js